/**
 * Stitch Supply custom cart confirmation.
 *
 * The Warehouse theme is placed in its native "message" cart mode by header.liquid,
 * so Add to Cart stays on the current page. This script shows a compact, responsive
 * confirmation using the theme's existing Total / View Cart / Checkout button styles.
 */
(function () {
  'use strict';

  var panel;
  var totalElement;
  var closeButton;
  var hideTimer;

  document.documentElement.classList.add('cart-confirmation-enabled');

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = precision == null ? 2 : precision;
    thousands = thousands == null ? ',' : thousands;
    decimal = decimal == null ? '.' : decimal;

    if (isNaN(number) || number == null) {
      return '0';
    }

    var fixed = (number / 100.0).toFixed(precision);
    var parts = fixed.split('.');
    var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    var cents = parts[1] ? decimal + parts[1] : '';

    return dollars + cents;
  }

  function formatMoney(cents) {
    var format = (window.theme && window.theme.moneyFormat) || '${{amount}}';
    var value;

    if (format.indexOf('{{amount_no_decimals_with_comma_separator}}') !== -1) {
      value = formatWithDelimiters(cents, 0, '.', ',');
      return format.replace('{{amount_no_decimals_with_comma_separator}}', value);
    }

    if (format.indexOf('{{amount_with_comma_separator}}') !== -1) {
      value = formatWithDelimiters(cents, 2, '.', ',');
      return format.replace('{{amount_with_comma_separator}}', value);
    }

    if (format.indexOf('{{amount_no_decimals}}') !== -1) {
      value = formatWithDelimiters(cents, 0, ',', '.');
      return format.replace('{{amount_no_decimals}}', value);
    }

    value = formatWithDelimiters(cents, 2, ',', '.');
    return format.replace('{{amount}}', value);
  }

  function setPanelTop() {
    if (!panel) {
      return;
    }

    var header = document.querySelector('.header');
    var top = 10;

    if (header) {
      var headerStyle = window.getComputedStyle(header);
      var headerBottomMargin = parseFloat(headerStyle.marginBottom) || 0;
      top = Math.max(10, Math.round(header.getBoundingClientRect().bottom + headerBottomMargin + 8));
    }

    panel.style.setProperty('--cart-add-confirmation-top', top + 'px');
  }

  function hidePanel() {
    if (!panel) {
      return;
    }

    window.clearTimeout(hideTimer);
    panel.setAttribute('aria-hidden', 'true');
  }

  function scheduleHide() {
    window.clearTimeout(hideTimer);
    hideTimer = window.setTimeout(function () {
      if (!panel.matches(':hover') && !panel.contains(document.activeElement)) {
        hidePanel();
      } else {
        scheduleHide();
      }
    }, 9000);
  }

  function showPanel() {
    if (!panel) {
      return;
    }

    setPanelTop();
    panel.setAttribute('aria-hidden', 'false');
    scheduleHide();
  }

  function refreshTotalAndShow() {
    fetch((window.routes && window.routes.cartUrl ? window.routes.cartUrl : '/cart') + '.js', {
      credentials: 'same-origin',
      headers: {
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('Unable to refresh cart');
      }

      return response.json();
    }).then(function (cart) {
      if (totalElement && typeof cart.total_price === 'number') {
        totalElement.textContent = formatMoney(cart.total_price);
      }

      showPanel();
    }).catch(function () {
      // The cart addition already succeeded. Show the confirmation even if the
      // follow-up total request is unavailable; Liquid supplied the prior total.
      showPanel();
    });
  }

  function initialize() {
    panel = document.getElementById('cart-add-confirmation');

    if (!panel) {
      return;
    }

    totalElement = panel.querySelector('[data-cart-confirmation-total]');
    closeButton = panel.querySelector('[data-cart-confirmation-close]');

    if (closeButton) {
      closeButton.addEventListener('click', hidePanel);
    }

    panel.addEventListener('mouseenter', function () {
      window.clearTimeout(hideTimer);
    });

    panel.addEventListener('mouseleave', scheduleHide);
    panel.addEventListener('focusin', function () {
      window.clearTimeout(hideTimer);
    });
    panel.addEventListener('focusout', scheduleHide);

    window.addEventListener('resize', setPanelTop);
    window.addEventListener('orientationchange', setPanelTop);
    window.addEventListener('scroll', setPanelTop, { passive: true });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && panel.getAttribute('aria-hidden') === 'false') {
        hidePanel();
      }
    });

    document.addEventListener('click', function (event) {
      if (panel.getAttribute('aria-hidden') === 'false' && !panel.contains(event.target)) {
        hidePanel();
      }
    });

    document.addEventListener('product:added', function () {
      // Let Shopify finish the successful add event, then read the authoritative cart total.
      window.setTimeout(refreshTotalAndShow, 0);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }
})();
